module.exports = __webpack_public_path__ + "static/media/video.51a98c93.svg";